import * as Yup from 'yup';
import { errorMessages } from '~/constants/errorMessages.ts';
import { blockedDomains } from '~/constants/common.ts';

export const clientTypeSchema = Yup.object().shape({
  value: Yup.string().required(errorMessages.FIELD_REQUIRED),
  label: Yup.string().required(errorMessages.FIELD_REQUIRED),
});

export const phoneValidation = Yup.string()
  .required(errorMessages.FIELD_REQUIRED)
  .test(
    'phone-validation',
    errorMessages.INVALID_INPUT_DATA,
    function (value: string | undefined): boolean {
      if (!value) return false;
      const cleanPhone = value.replace(/[\s\-()]/g, '');
      if (cleanPhone.startsWith('+380')) {
        return /^\+380\d{9}$/.test(cleanPhone);
      } else {
        return /^\+\d{1,3}\d{5}$/.test(cleanPhone);
      }
    }
  );

export const emailValidation = Yup.string()
  .required(errorMessages.FIELD_REQUIRED)
  .test('contains-at', errorMessages.MISSING_SYMBOL, (value: string | undefined): boolean =>
    value ? value.includes('@') : false
  )
  .email(errorMessages.INVALID_EMAIL_FORMAT)
  .test(
    'blocked-domain',
    errorMessages.BLOCKED_EMAIL_DOMAIN,
    function (value: string | undefined): boolean {
      if (!value || !value.includes('@')) return true;
      const domain = value.split('@')[1];
      return !blockedDomains.some(
        (blocked: string) => domain === blocked || domain?.endsWith(`.${blocked}`)
      );
    }
  )
  .required(errorMessages.FIELD_REQUIRED);

export const conditionalClientTypeValidation = (fieldName: string) =>
  Yup.object()
    .shape({
      value: Yup.string().required(errorMessages.FIELD_REQUIRED),
      label: Yup.string().required(errorMessages.FIELD_REQUIRED),
    })
    .nullable()
    .when(fieldName, {
      is: true,
      then: (schema) => schema.required(errorMessages.FIELD_REQUIRED),
      otherwise: (schema) => schema.notRequired().nullable(),
    });
